/* HemlikCare — tema etkileşimleri (bağımlılıksız; Lenis isteğe bağlı) */
(() => {
  'use strict';

  const HC = window.HC || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  // true the first time an element is initialised for a given feature (theme editor reloads re-run inits)
  const once = (el, key) => { const k = `hc${key}`; if (el.dataset[k]) return false; el.dataset[k] = '1'; return true; };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    const fmt = HC.moneyFormat || '{{amount}} TL';
    const value = (cents / 100);
    const withDelim = (n, dec, thou, decSep) =>
      n.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, '\u0000').replace('.', decSep).replace(/\u0000/g, thou);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return withDelim(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelim(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelim(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelim(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelim(value, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return withDelim(value, 2, "'", '.');
        default: return withDelim(value, 2, '.', ',');
      }
    });
  }

  /* ---------- scroll engine ---------- */
  const scrollSubs = new Set();
  let lenis = null;
  let ticking = false;
  const runScroll = () => {
    ticking = false;
    const y = window.scrollY;
    scrollSubs.forEach((fn) => fn(y));
  };
  const requestScroll = () => {
    if (!ticking) { ticking = true; requestAnimationFrame(runScroll); }
  };
  window.addEventListener('scroll', requestScroll, { passive: true });
  window.addEventListener('resize', requestScroll, { passive: true });

  function initSmoothScroll() {
    if (lenis || !HC.smoothScroll || reduceMotion || !window.Lenis || !finePointer) return;
    // İç içe kaydırılabilen alanlar (ör. Releasit COD formu, uygulama pencereleri) kendi kaydırmasını kullanır
    const inNestedScroller = (node) => {
      for (let el = node; el && el !== document.body && el !== document.documentElement; el = el.parentElement) {
        if (el.nodeType !== 1) continue;
        const oy = getComputedStyle(el).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 1) return true;
      }
      return false;
    };
    lenis = new window.Lenis({ duration: 1.15, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true, prevent: inNestedScroller });
    const raf = (time) => { lenis.raf(time); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    lenis.on('scroll', requestScroll);
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute('href');
      if (id.length < 2) return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -70 });
    });
  }

  /* ---------- preloader ---------- */
  function initPreloader() {
    const el = $('[data-preloader]');
    if (!el) return;
    let seen = false;
    try { seen = sessionStorage.getItem('hc-intro') === '1'; } catch (e) { /* storage blocked */ }
    if (seen || reduceMotion) { el.remove(); return; }
    try { sessionStorage.setItem('hc-intro', '1'); } catch (e) { /* storage blocked */ }
    document.documentElement.style.overflow = 'hidden';
    const finish = () => {
      el.classList.add('is-done');
      document.documentElement.style.overflow = '';
      setTimeout(() => el.remove(), 1100);
    };
    setTimeout(finish, 900);
  }

  /* ---------- split text ---------- */
  function splitWords(el) {
    if (el.dataset.splitDone) return;
    el.dataset.splitDone = '1';
    const words = el.textContent.trim().split(/\s+/);
    // the readable copy lives in a visually hidden span; aria-label is not allowed on a plain span
    el.innerHTML = `<span class="visually-hidden">${el.textContent.trim().replace(/</g, '&lt;')}</span>` + words.map((w, i) => `<span class="w" aria-hidden="true" style="--i:${i}"><span>${w.replace(/</g, '&lt;')}</span></span>`).join(' ');
  }

  /* ---------- reveal on view ---------- */
  function initReveal() {
    $$('[data-split]').forEach(splitWords);
    // the opening section animates in right away; waiting for it to scroll into view made the buttons feel late on phones
    $$('[data-hero] [data-reveal], [data-hero] [data-split]').forEach((el) => requestAnimationFrame(() => el.classList.add('is-in')));
    const targets = $$('[data-reveal], [data-split], .stat, .insight, .ctable, .value__row').filter((el) => !el.closest('[data-hero]'));
    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach((t) => t.classList.add('is-in'));
      $$('[data-count]').forEach((c) => { c.textContent = c.dataset.count; });
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        $$('[data-count]', entry.target).forEach(countUp);
        if (entry.target.matches('[data-count]')) countUp(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    targets.forEach((t) => io.observe(t));
  }

  function countUp(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    const end = parseFloat(el.dataset.count) || 0;
    const dur = 1800;
    const start = performance.now();
    const step = (now) => {
      const t = clamp((now - start) / dur, 0, 1);
      const eased = 1 - Math.pow(1 - t, 4);
      el.textContent = Math.round(end * eased);
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  /* ---------- header + progress ---------- */
  function initHeader() {
    const header = $('[data-header]');
    if (header && !once(header, 'Header')) return;
    const bar = $('.scroll-progress');
    let lastY = 0;
    // Menünün yapışmaya başladığı nokta: üstündeki duyuru şeridinin altı
    const prev = header && header.parentElement.previousElementSibling;
    const stickAt = () => (prev && prev.classList.contains('shopify-section') ? prev.offsetTop + prev.offsetHeight : 0);
    scrollSubs.add((y) => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (bar) bar.style.setProperty('--sp', max > 0 ? (y / max).toFixed(4) : 0);
      if (!header) return;
      const menuOpen = document.documentElement.classList.contains('menu-open');
      // Aşağı kaydırırken menü takip etmez, yalnızca yukarı kaydırınca geri gelir.
      if (y > stickAt() && y > lastY && !menuOpen) header.classList.add('is-hidden');
      else if (y < lastY - 2 || y <= stickAt()) header.classList.remove('is-hidden');
      lastY = y;
    });

    const menu = $('[data-mobile-menu]');
    const openBtn = $('[data-menu-open]');
    if (!menu || !openBtn) return;
    const setOpen = (open) => {
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', String(!open));
      menu.inert = !open;
      openBtn.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('menu-open', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (lenis) open ? lenis.stop() : lenis.start();
    };
    openBtn.addEventListener('click', () => setOpen(true));
    $$('[data-menu-close]', menu).forEach((b) => b.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
  }

  /* ---------- hero pointer glow ---------- */
  function initHero() {
    const hero = $('[data-hero]');
    if (!hero || !finePointer) return;
    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      hero.style.setProperty('--mx', `${((e.clientX - r.left) / r.width) * 100}%`);
      hero.style.setProperty('--my', `${((e.clientY - r.top) / r.height) * 100}%`);
    });
  }

  /* progress of a tall section scrolled through its sticky child: 0 → 1 */
  function sectionProgress(el) {
    const r = el.getBoundingClientRect();
    const total = r.height - window.innerHeight;
    return total > 0 ? clamp(-r.top / total, 0, 1) : 0;
  }

  /* ---------- story (pinned) ---------- */
  function initStory() {
    $$('[data-story]').forEach((story) => {
      if (!once(story, 'Story')) return;
      const chapters = $$('[data-story-chapter]', story);
      const dots = $$('[data-story-dot]', story);
      const o2 = $('.o2', story);
      const o2Value = $('[data-o2-value]', story);
      const scenes = $$('[data-story-scene]', story);
      const ticks = $$('[data-story-tick]', story);
      if (!chapters.length) return;
      let current = -1;
      let shown = 100;

      const animateO2 = (to) => {
        const from = shown;
        const start = performance.now();
        const tick = (now) => {
          const t = clamp((now - start) / 1200, 0, 1);
          shown = Math.round(from + (to - from) * (1 - Math.pow(1 - t, 3)));
          if (o2Value) o2Value.textContent = shown;
          if (t < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      };

      const activate = (i) => {
        if (i === current) return;
        current = i;
        chapters.forEach((c, k) => {
          c.classList.toggle('is-active', k === i);
          c.classList.toggle('is-past', k < i);
        });
        dots.forEach((d, k) => d.classList.toggle('is-on', k <= i));
        scenes.forEach((s) => s.classList.toggle('is-active', Number(s.dataset.storyScene) === i));
        ticks.forEach((tk, k) => { tk.classList.toggle('is-active', k === i); tk.classList.toggle('is-past', k < i); });
        const ch = chapters[i];
        const oxygen = Number(ch.dataset.oxygen || 100);
        const isFinal = ch.dataset.final === 'true';
        if (o2) {
          o2.style.setProperty('--o2', oxygen);
          o2.style.setProperty('--beat', `${0.6 + oxygen / 100}s`);
        }
        story.classList.toggle('is-final', isFinal);
        story.classList.toggle('is-danger', !isFinal && oxygen < 60);
        animateO2(oxygen);
      };

      if (reduceMotion) { activate(chapters.length - 1); return; }
      scrollSubs.add(() => {
        const p = sectionProgress(story);
        activate(clamp(Math.floor(p * chapters.length * 0.999), 0, chapters.length - 1));
      });
      activate(0);
    });
  }

  /* ---------- how it works (scrubbed device) ---------- */
  function initHow() {
    $$('[data-how]').forEach((how) => {
      if (!once(how, 'How')) return;
      const steps = $$('[data-how-step]', how);
      const wrap = $('.how__device-wrap', how);
      const phaseLabel = $('[data-how-phase]', how);
      const phaseBar = $('.how__phase-bar', how);
      const caps = {
        press: $('[data-how-caption="press"] strong', how),
        pull: $('[data-how-caption="pull"] strong', how)
      };
      const restLabel = phaseLabel ? phaseLabel.textContent : '';
      if (reduceMotion) {
        steps.forEach((s) => s.classList.add('is-active'));
        return;
      }
      scrollSubs.add(() => {
        const p = sectionProgress(how);
        const stepIndex = clamp(Math.floor(p * steps.length * 0.999), 0, steps.length - 1);
        steps.forEach((s, k) => s.classList.toggle('is-active', k === stepIndex));

        // device: 0–.12 rest, .12–.5 mask connection highlighted, .5–.92 handle pulled up
        let dp = 0;
        let phase = 'rest';
        if (p > 0.12 && p <= 0.5) phase = 'press';
        else if (p > 0.5) { dp = -clamp((p - 0.5) / 0.42, 0, 1); phase = 'pull'; }
        if (wrap) wrap.style.setProperty('--p', dp.toFixed(3));
        how.classList.toggle('is-press', phase === 'press');
        how.classList.toggle('is-pull', phase === 'pull');
        if (phaseLabel) {
          phaseLabel.textContent = phase === 'press' && caps.press ? caps.press.textContent
            : phase === 'pull' && caps.pull ? caps.pull.textContent : restLabel;
        }
        if (phaseBar) phaseBar.style.setProperty('--hp', p.toFixed(3));
      });
    });
  }

  /* ---------- parallax ---------- */
  function initParallax() {
    const els = $$('[data-parallax]').filter((el) => once(el, 'Parallax'));
    if (!els.length || reduceMotion) return;
    scrollSubs.add(() => {
      const vh = window.innerHeight;
      els.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const speed = parseFloat(el.dataset.parallax) || 0.1;
        const offset = (r.top + r.height / 2 - vh / 2) * speed;
        el.style.translate = `0 ${offset.toFixed(1)}px`;
      });
    });
  }

  /* ---------- magnetic buttons + tilt ---------- */
  function initPointerFX() {
    if (!finePointer || reduceMotion) return;
    $$('[data-magnetic]').forEach((el) => {
      if (!once(el, 'Magnetic')) return;
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) * 0.05;
        const y = (e.clientY - r.top - r.height / 2) * 0.08;
        el.style.transform = `translate(${x}px, ${y}px)`;
      });
      el.addEventListener('pointerleave', () => { el.style.transform = ''; });
    });
    $$('[data-tilt]').forEach((el) => {
      if (!once(el, 'Tilt')) return;
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const rx = ((e.clientY - r.top) / r.height - 0.5) * -2.5;
        const ry = ((e.clientX - r.left) / r.width - 0.5) * 3;
        el.style.transform = `perspective(1200px) rotateX(${rx}deg) rotateY(${ry}deg) translateY(-3px)`;
      });
      el.addEventListener('pointerleave', () => { el.style.transform = ''; });
    });
  }

  /* ---------- accordions (smooth height) ---------- */
  function initAccordions() {
    $$('details.accordion').forEach((d) => {
      if (!once(d, 'Accordion')) return;
      const summary = $('summary', d);
      const content = $('.accordion__content', d);
      if (!summary || !content || reduceMotion) return;
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (d.dataset.animating) return;
        d.dataset.animating = '1';
        if (!d.open) {
          d.open = true;
          const h = content.scrollHeight;
          content.animate([{ height: '0px', opacity: 0 }, { height: `${h}px`, opacity: 1 }], { duration: 450, easing: 'cubic-bezier(.16,1,.3,1)' })
            .onfinish = () => { delete d.dataset.animating; };
        } else {
          const h = content.scrollHeight;
          content.animate([{ height: `${h}px`, opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 350, easing: 'cubic-bezier(.65,0,.35,1)' })
            .onfinish = () => { d.open = false; delete d.dataset.animating; };
        }
      });
    });
  }

  /* ---------- gallery ---------- */
  function initGalleries() {
    $$('[data-gallery]').forEach((g) => {
      if (!once(g, 'Gallery')) return;
      const slides = $$('[data-slide]', g);
      const thumbs = $$('[data-thumb]', g);
      if (slides.length < 2) return;
      let i = 0;
      const go = (n) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
        thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
        const active = thumbs[i];
        if (active) active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      };
      thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.thumb))));
      const prev = $('[data-gallery-prev]', g);
      const next = $('[data-gallery-next]', g);
      if (prev) prev.addEventListener('click', () => go(i - 1));
      if (next) next.addEventListener('click', () => go(i + 1));
      let sx = null;
      const stage = $('.gallery__stage', g);
      stage.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
        sx = null;
      });
    });
  }

  /* ---------- buybox: bundles, variants, delivery, sticky bar ---------- */
  function initBuybox() {
    $$('[data-buybox]').forEach((box) => {
      if (!once(box, 'Buybox')) return;
      const form = $('[data-product-form]', box);
      const qty = $('[data-quantity]', box);
      const idInput = $('[data-variant-id]', box);
      const priceEl = $('[data-price]', box);
      const compareEl = $('[data-compare]', box);
      const bundles = $$('[data-bundle]', box);
      let unit = { price: 0, compare: 0 };
      try { unit = JSON.parse(box.dataset.productJson); } catch (e) { /* keep defaults */ }

      const renderBundlePrices = () => {
        bundles.forEach((b) => {
          const count = Number(b.dataset.bundle);
          const pct = Number(b.dataset.pct) || 0;
          const full = unit.price * count;
          const line = Math.floor((full * (100 - pct)) / 10000) * 100; // whole lira, matches the Liquid rounding
          const strong = $('[data-bundle-price]', b);
          const strike = $('[data-bundle-compare]', b);
          const save = $('[data-bundle-save]', b);
          if (strong) strong.textContent = formatMoney(line);
          if (strike) strike.textContent = formatMoney(pct > 0 ? full : (unit.compare || full));
          if (save) save.textContent = formatMoney(full - line).replace(/[.,]00(?=\D*$)/, '');
        });
      };

      // Kapıda ödeme butonundaki toplam: seçili paket fiyatı + kapıda ödeme bedeli
      const codTotal = $('[data-cod-total]', box);
      const codFee = Number(($('[data-cod]', box) || {}).dataset?.codFee) || 0;
      const updateCodTotal = () => {
        if (!codTotal) return;
        const b = bundles.find((x) => x.classList.contains('is-active'));
        const count = b ? Number(b.dataset.bundle) : 1;
        const pct = b ? Number(b.dataset.pct) || 0 : 0;
        const line = Math.floor((unit.price * count * (100 - pct)) / 10000) * 100;
        codTotal.textContent = formatMoney(line + codFee);
      };

      bundles.forEach((b) => {
        const input = $('input', b);
        input.addEventListener('change', () => {
          bundles.forEach((x) => x.classList.toggle('is-active', x === b));
          if (qty) qty.value = b.dataset.bundle;
          updateCodTotal();
        });
      });

      $$('input[name="variant-pick"]', box).forEach((r) => {
        r.addEventListener('change', () => {
          if (!r.checked) return;
          idInput.value = r.value;
          unit = { price: Number(r.dataset.price), compare: Number(r.dataset.compare) };
          if (priceEl) priceEl.textContent = formatMoney(unit.price);
          if (compareEl) compareEl.textContent = unit.compare > unit.price ? formatMoney(unit.compare) : '';
          renderBundlePrices();
          updateCodTotal();
          const url = new URL(window.location.href);
          if (url.pathname.includes('/products/')) {
            url.searchParams.set('variant', r.value);
            history.replaceState({}, '', url);
          }
        });
      });

      const delivery = $('[data-delivery]', box);
      if (delivery) {
        const addBusinessDays = (d, n) => {
          const out = new Date(d);
          let added = 0;
          while (added < n) {
            out.setDate(out.getDate() + 1);
            const day = out.getDay();
            if (day !== 0 && day !== 6) added += 1;
          }
          return out;
        };
        const now = new Date();
        const fmt = new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long', weekday: 'short' });
        const min = addBusinessDays(now, Number(delivery.dataset.min || 2));
        const max = addBusinessDays(now, Number(delivery.dataset.max || 4));
        $('[data-delivery-range]', delivery).textContent = `${fmt.format(min)} – ${fmt.format(max)}`;
      }

      const sticky = $('[data-sticky-atc]', box.closest('section') || document);
      const atc = $('[data-add-to-cart]', box);
      if (sticky && atc) {
        const stickyBtn = $('button', sticky);
        let shown = null;
        scrollSubs.add(() => {
          // visible once the main button has scrolled above the viewport
          const show = atc.getBoundingClientRect().bottom < 0;
          if (show === shown) return;
          shown = show;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', String(!show));
          if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        });
      }

      $$('[data-copy]', box).forEach((b) => b.addEventListener('click', () => {
        const label = $('[data-copy-label]', b);
        const code = b.dataset.copy;
        const done = () => { if (!label) return; label.textContent = 'Kopyalandı'; setTimeout(() => { label.textContent = code; }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done).catch(done);
        else done();
      }));

      if (form) form.addEventListener('submit', (e) => onAddToCart(e, form));
    });
  }

  /* ---------- cart (AJAX + drawer) ---------- */
  const drawer = () => $('[data-cart-drawer]');

  function openDrawer() {
    const d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    d.inert = false;
    document.documentElement.style.overflow = 'hidden';
    if (lenis) lenis.stop();
    const close = $('.drawer__head [data-cart-close]', d);
    if (close) close.focus({ preventScroll: true });
  }

  function closeDrawer() {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    d.inert = true;
    document.documentElement.style.overflow = '';
    if (lenis) lenis.start();
  }

  async function fetchCart() {
    const res = await fetch(`${HC.routes.cart}.js`, { headers: { Accept: 'application/json' } });
    return res.json();
  }

  function renderCart(cart) {
    const d = drawer();
    if (!d) return;
    const list = $('[data-cart-items]', d);
    const total = $('[data-cart-total]', d);
    const count = $('[data-cart-count]', d);
    const badge = $('[data-cart-badge]');
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    if (!cart.items.length) {
      list.innerHTML = `<div class="drawer__empty"><p>${esc(HC.strings.empty)}</p></div>`;
    } else {
      list.innerHTML = cart.items.map((item) => {
        const img = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=200` : '';
        const variant = item.variant_title && !item.product_has_only_default_variant ? `<p class="dline__variant">${esc(item.variant_title)}</p>` : '';
        const orig = item.original_line_price > item.final_line_price ? `<s>${formatMoney(item.original_line_price)}</s>` : '';
        return `
          <div class="dline" data-key="${esc(item.key)}">
            ${img ? `<img class="dline__img" src="${esc(img)}" alt="" loading="lazy">` : '<span class="dline__img"></span>'}
            <div>
              <a class="dline__title" href="${esc(item.url)}">${esc(item.product_title)}</a>
              ${variant}
              <div class="dline__qty">
                <button type="button" data-qty="${item.quantity - 1}" aria-label="Azalt"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 12h14"/></svg></button>
                <span>${item.quantity}</span>
                <button type="button" data-qty="${item.quantity + 1}" aria-label="Arttır"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 5v14M5 12h14"/></svg></button>
              </div>
            </div>
            <div class="dline__right">
              <span class="dline__price">${formatMoney(item.final_line_price)}${orig}</span>
              <button type="button" class="dline__remove" data-qty="0">${esc(HC.strings.remove)}</button>
            </div>
          </div>`;
      }).join('');
    }
    if (total) total.textContent = formatMoney(cart.total_price);
    if (count) count.textContent = `(${cart.item_count})`;
    if (badge) {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
      badge.classList.remove('is-bump');
      void badge.offsetWidth;
      badge.classList.add('is-bump');
    }

    const meter = $('[data-ship-meter]', d);
    if (meter && HC.freeShipping > 0) {
      const left = HC.freeShipping - cart.total_price;
      const pct = clamp((cart.total_price / HC.freeShipping) * 100, 0, 100);
      $('[data-ship-bar]', meter).parentElement.style.setProperty('--pct', `${pct}%`);
      $('[data-ship-bar]', meter).style.width = `${pct}%`;
      $('[data-ship-text]', meter).textContent = left > 0
        ? HC.strings.freeLeft.replace('[amount]', formatMoney(left))
        : HC.strings.freeDone;
    }
  }

  async function changeLine(key, quantity) {
    const d = drawer();
    d.classList.add('is-loading');
    try {
      const res = await fetch(`${HC.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      renderCart(await res.json());
    } catch (e) {
      console.error(e);
    } finally {
      d.classList.remove('is-loading');
    }
  }

  async function onAddToCart(e, form) {
    const isCod = !!(e.submitter && e.submitter.value === 'cod');
    // Releasit COD formu yüklüyse kapıda ödeme onun açılır formuyla alınır (seçili paket adedini formdan okur)
    const rsi = isCod && (form.querySelector('#rsi_buy_now_button') || document.querySelector('#rsi_buy_now_button'));
    if (rsi) {
      e.preventDefault();
      rsi.click();
      return;
    }
    const modeInput = $('[data-buy-mode]', form);
    const toCheckout = isCod || (modeInput && modeInput.value === 'checkout');
    if (!toCheckout && !drawer()) return;
    e.preventDefault();
    const btn = isCod ? e.submitter : $('[data-add-to-cart]', form);
    const label = btn ? $('.btn__label', btn) : null;
    const original = label ? label.innerHTML : '';
    if (btn) btn.disabled = true;
    try {
      const res = await fetch(`${HC.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || HC.strings.error);
      }
      if (toCheckout) {
        // record the customer's payment choice on the order, then go straight to checkout
        await fetch(`${HC.routes.cart}/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Ödeme tercihi': isCod ? 'Kapıda ödeme' : 'Online ödeme' } })
        }).catch(() => {});
        window.location.href = '/checkout';
        return;
      }
      if (label) label.textContent = HC.strings.added;
      renderCart(await fetchCart());
      openDrawer();
    } catch (err) {
      if (label) label.textContent = err.message || HC.strings.error;
    } finally {
      setTimeout(() => {
        if (btn) btn.disabled = false;
        if (label) label.innerHTML = original;
      }, 1600);
    }
  }

  function initCart() {
    const d = drawer();
    if (!d) return;
    $$('[data-cart-close]', d).forEach((b) => b.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
    $$('[data-cart-open]').forEach((a) => a.addEventListener('click', async (e) => {
      e.preventDefault();
      renderCart(await fetchCart());
      openDrawer();
    }));
    d.addEventListener('click', (e) => {
      const b = e.target.closest('[data-qty]');
      if (!b) return;
      const line = b.closest('[data-key]');
      if (line) changeLine(line.dataset.key, Number(b.dataset.qty));
    });
    fetchCart().then(renderCart).catch(() => {});
  }

  /* ---------- video cards + drag scroll ---------- */
  function initVideos() {
    $$('[data-vcard]').forEach((card) => {
      if (!once(card, 'Video')) return;
      const video = $('video', card);
      if (!video) return;
      const play = () => { video.play().then(() => card.classList.add('is-playing')).catch(() => {}); };
      const stop = () => { video.pause(); video.muted = true; card.classList.remove('is-playing', 'has-sound'); };
      if (finePointer) {
        card.addEventListener('mouseenter', () => { if (video.paused) play(); });
        card.addEventListener('mouseleave', () => { if (video.muted) stop(); });
      }
      // Tıklama: sesli oynat; sesli oynarken tıklama durdurur. Aynı anda tek video sesli çalar.
      card.addEventListener('click', () => {
        if (!video.paused && !video.muted) return stop();
        $$('[data-vcard].has-sound').forEach((c) => { if (c !== card) { const v = $('video', c); v.pause(); v.muted = true; c.classList.remove('is-playing', 'has-sound'); } });
        video.muted = false;
        card.classList.add('has-sound');
        play();
      });
    });

    $$('[data-drag-scroll]').forEach((el) => {
      if (!finePointer || !once(el, 'Drag')) return;
      let down = false; let sx = 0; let sl = 0; let moved = false;
      el.addEventListener('pointerdown', (e) => { down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; });
      window.addEventListener('pointerup', () => { down = false; el.classList.remove('is-dragging'); });
      el.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - sx;
        if (Math.abs(dx) > 4) { moved = true; el.classList.add('is-dragging'); }
        el.scrollLeft = sl - dx;
      });
      el.addEventListener('click', (e) => { if (moved) { e.stopPropagation(); e.preventDefault(); } }, true);
    });
  }

  /* ---------- yasal sayfa: içindekiler ---------- */
  function initLegal() {
    const toc = $('[data-legal-toc]');
    const body = $('[data-legal-body]');
    if (!toc || !body || !once(toc, 'Legal')) return;
    const list = $('ol', toc);
    const tr = { ç: 'c', ğ: 'g', ı: 'i', İ: 'i', ö: 'o', ş: 's', ü: 'u' };
    const slug = (t) => t.toLocaleLowerCase('tr').replace(/[çğıiöşü]/g, (c) => tr[c] || c).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const heads = $$('h2', body);
    if (!heads.length) { toc.hidden = true; return; }
    const links = heads.map((h, i) => {
      if (!h.id) h.id = slug(h.textContent) || `bolum-${i + 1}`;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });
    // Mobilde içindekiler kapalı başlar, seçimden sonra kapanır
    const mq = window.matchMedia('(max-width: 960px)');
    if (mq.matches) toc.open = false;
    list.addEventListener('click', (e) => { if (e.target.closest('a') && mq.matches) toc.open = false; });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        links.forEach((a) => a.classList.toggle('is-active', a.hash === `#${en.target.id}`));
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    heads.forEach((h) => io.observe(h));
  }

  /* ---------- Releasit COD: telefon başındaki 0'ı sil ---------- */
  // Formda +90 öneki sabit; müşteri alışkanlıkla 0 yazarsa 10 hanelik sınır son haneyi keser.
  const nativeValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  document.addEventListener('input', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement) || t.type !== 'tel' || !/5XX/.test(t.placeholder)) return;
    const clean = t.value.replace(/^[\s0]+/, '');
    if (clean === t.value) return;
    nativeValue.call(t, clean);
    t.dispatchEvent(new Event('input', { bubbles: true }));
  }, true);

  /* ---------- boot ---------- */
  function boot() {
    initPreloader();
    initSmoothScroll();
    HC.initSmoothScroll = initSmoothScroll;
    initReveal();
    initHeader();
    initHero();
    initStory();
    initHow();
    initParallax();
    initPointerFX();
    initAccordions();
    initGalleries();
    initBuybox();
    initCart();
    initVideos();
    initLegal();
    requestScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-run inits when a section reloads
  // (re-rendered sections are new DOM nodes, so `once` lets them initialise while existing ones are skipped)
  document.addEventListener('shopify:section:load', () => {
    initReveal(); initHeader(); initStory(); initHow(); initParallax(); initPointerFX(); initAccordions(); initGalleries(); initBuybox(); initVideos(); initLegal();
    requestScroll();
  });
})();
